var scopedState = new Map();
export var createSdkState = function (initialState, metaData, suffixId) {
    var uniqueId = suffixId
        ? metaData.compId + "-" + suffixId
        : metaData.compId;
    var setSdkState = function (newState) {
        scopedState.set(uniqueId, Object.assign(scopedState.get(uniqueId), newState));
    };
    if (!scopedState.has(uniqueId) || process.env.NODE_ENV === 'test') {
        scopedState.set(uniqueId, initialState);
    }
    var state = scopedState.get(uniqueId);
    return [state, setSdkState];
};
//# sourceMappingURL=createSdkState.js.map